import { modules } from "@/helpers/variables/modules";

export const signRoutes = [
  {
    path: "/sign",
    name: "SignMain",
    component: () => import("@/views/sign/Main.vue"),
    meta: {
      layout: "dashboard",
      requiresAuth: true,
      app: modules.sign,
      planProductRequired: modules.sign,
      userPermissionRequired: "users",
      breadCrumb: [
        {
          text: "Início",
          to: { name: "Home" },
        },
        {
          text: "Conecta Sign",
        },
      ],
    },
  },
  {
    path: "/sign/template",
    redirect: "/sign/email-signature/templates",
  },
  {
    path: "/sign/email-signature/templates",
    name: "SignTemplates",
    component: () => import("@/views/sign/signature_templates/Templates.vue"),
    meta: {
      layout: "dashboard",
      requiresAuth: true,
      app: modules.sign,
      planProductRequired: modules.sign,
      userPermissionRequired: "users",
      breadCrumb: [
        {
          text: "Início",
          to: { name: "Home" },
        },
        {
          text: "Conecta Sign",
          to: { name: "SignMain" },
        },
        {
          text: "Modelos de assinatura",
        },
      ],
    },
  },
  /* EDITOR DRAG & DROP */
  {
    path: "/sign/email-signature/:key/edit/",
    name: "SignDragInDropEditor",
    component: () => import("@/views/sign/signature_templates/SignEditor.vue"),
    meta: {
      layout: "editor",
      requiresAuth: true,
      app: modules.sign,
      planProductRequired: modules.sign,
      userPermissionRequired: "users",
    },
  },
  {
    path: "/sign/email-signature/new",
    name: "SignSelectEditor",
    component: () =>
      import("@/views/sign/signature_templates/SelectEditorType.vue"),
    meta: {
      layout: "dashboard",
      requiresAuth: true,
      app: modules.sign,
      planProductRequired: modules.sign,
      userPermissionRequired: "users",
    },
  },
  {
    path: "/sign/template/:key",
    redirect: "/sign/email-signature/:key",
  },
  {
    path: "/sign/email-signature/:key",
    name: "TemplateEdit",
    component: () =>
      import("@/views/sign/signature_templates/TemplateEditor.vue"),
    meta: {
      layout: "dashboard",
      requiresAuth: true,
      app: modules.sign,
      planProductRequired: modules.sign,
      userPermissionRequired: "users",
    },
  },
  {
    path: "/sign/organization-units",
    name: "SignOrganizationUnits",
    redirect: "/users",
  },
  {
    path: "/sign/users",
    redirect: "/users",
  },
  {
    path: "/sign/batch-users",
    redirect: "/users",
  },
  {
    path: "/sign/users/apply",
    name: "ApplySignTemplates",
    redirect: "/users",
  },
  {
    path: "/sign/users/sign-automation",
    name: "SignAutomation",
    component: () => import("@/views/sign/users/SignAutomation.vue"),
    meta: {
      layout: "dashboard",
      requiresAuth: true,
      app: modules.control,
      planProductRequired: modules.sign,
      userPermissionRequired: "users",
      breadCrumb: [
        {
          text: "Início",
          to: { name: "Home" },
        },
        {
          text: "Conecta Sign",
          to: { name: "SignMain" },
        },
        {
          text: "Aplicação automática",
        },
      ],
    },
  },
  {
    path: "/sign/company-tags",
    redirect: "/settings/profile",
    name: "SignTags",
  },
  {
    path: "/sign/templates/vacation-messages",
    name: "VacationMessageTemplates",
    component: () => import("@/views/sign/vacation/MessageTemplates.vue"),
    meta: {
      layout: "dashboard",
      requiresAuth: true,
      app: modules.sign,
      planProductRequired: modules.sign,
      userPermissionRequired: "users",
      breadCrumb: [
        {
          text: "Início",
          to: { name: "Home" },
        },
        {
          text: "Conecta Sign",
          to: { name: "SignMain" },
        },
        {
          text: "Modelos de mensagens de férias",
        },
      ],
    },
  },
  {
    path: "/sign/templates/vacation-message/new",
    name: "NewVacationTemplate",
    component: () => import("@/views/sign/vacation/NewVacationTemplate.vue"),
    meta: {
      layout: "dashboard",
      requiresAuth: true,
      app: modules.sign,
      planProductRequired: modules.sign,
      userPermissionRequired: "users",
      breadCrumb: [
        {
          text: "Início",
          to: { name: "Home" },
        },
        {
          text: "Conecta Sign",
          to: { name: "SignMain" },
        },
        {
          text: "Modelos de mensagens de férias",
          to: { name: "VacationMessageTemplates" },
        },
        {
          text: "Criar modelo",
        },
      ],
    },
  },
  {
    path: "/sign/templates/vacation-message/:id",
    name: "VacationTemplateEdit",
    component: () => import("@/views/sign/vacation/NewVacationTemplate.vue"),
    meta: {
      layout: "dashboard",
      requiresAuth: true,
      app: modules.sign,
      planProductRequired: modules.sign,
      userPermissionRequired: "users",
    },
  },
  {
    path: "/sign/vacation-message",
    name: "VacationMessage",
    component: () => import("@/views/sign/vacation/ApplyVacationMessage.vue"),
    meta: {
      layout: "dashboard",
      requiresAuth: true,
      app: modules.suite,
      planProductRequired: modules.sign,
      userPermissionRequired: "users",
    },
  },
];
